// src/utils/utils.js
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken'); // Use 'authToken' consistent with App.js
  if (!token) {
    return { 'Content-Type': 'application/json' };
  }
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
};
